const translations = {
  en: {
    welcome: 'Welcome to Patient Portal!',
    portalDesc: 'This is your private Patient portal. Manage your account and data here.',
    dashboard: 'Dashboard',
    gotoDashboard: 'Go to Dashboard',
    close: 'Close',
    logout: 'Logout',
    account: 'Account',
    accountDesc: 'View and update your account data and preferences',
    manageAccount: 'Manage Account',
    contact: 'Contact Info',
    contactDesc: 'Update your contact details and address',
    manageContacts: 'Manage Contacts',
    primaryPhoneNumber: 'Primary Phone Number',
    secondaryPhoneNumber: 'Secondary Phone Number',
    secondaryMobileNumber: 'Secondary Mobile Number',
    bloodType: 'Blood Type',
    dateOfBirth: 'Date of Birth',
    ssn: 'Social Security Number',
    ekg: 'EKG',
    profile: 'Profile',
    profileDesc: 'Manage your profile and basic personal data',
    profileDetails: 'Profile Details',
    lifestyle: 'Lifestyle',
    lifestyleDesc: 'Details about your routines are useful in an emergency',
    dayToDay: 'Your Day to Day',
    yourDayToDay: 'Your Day to Day',
    physiciansAndSpecialists: 'Physicians & Specialists',
    hospitalsAndClinics: 'Hospitals & Clinics',
    prescriptionsAndSupplements: 'Prescriptions & Supplements',
    injuriesAndIllnesses: 'Injuries & Illnesses',
    surgeriesTherapy: 'Surgeries & Therapy',
    familyMedicalHistory: 'Family Medical History',
    salMineCard: 'SAL Mine Card',
    doctors: 'Doctors',
    doctorsDesc: 'Share data with your medical service doctors',
    physicians: 'Physicians and Specialists',
    hospitals: 'Hospitals',
    hospitalsDesc: 'Share data with your medical institutions',
    hospitalsClinics: 'Hospitals and Clinics',
    documents: 'Documents',
    documentsDesc: 'Upload your medical records and manage access',
    manageRecords: 'Manage Records',
    medications: 'Medications',
    medicationsDesc: 'Tell us about your medications and supplements',
    prescriptions: 'Prescriptions and Supplements',
    conditions: 'Conditions',
    conditionsDesc: 'Tell us about injuries, illnesses, and accidents',
    injuries: 'Injuries and Illnesses',
    procedures: 'Procedures',
    proceduresDesc: "Tell us about medical procedures you've undergone",
    surgeries: 'Surgeries, Therapy',
    therapyTreatment: 'Therapy & Treatment',
    addTherapy: 'Add Therapy/Treatment',
    myTherapies: 'My Therapies',
    frequency: 'Frequency',
    duration: 'Duration',
    description: 'Description',
    medicalDevices: 'Medical Devices',
    addDevice: 'Add Medical Device',
    myDevices: 'My Medical Devices',
    deviceName: 'Device Name',
    deviceType: 'Device Type',
    brand: 'Brand',
    model: 'Model',
    allergies: 'Allergies',
    allergiesDesc: "Tell us about what your body doesn't agree with",
    allergens: 'Allergens',
    history: 'History',
    historyDesc: 'Health information about close relatives',
    familyHistory: 'Family Medical History',
    salCard: 'SAL Mine Card',
    salCardDesc: 'View, Order, or Print your SAL Mine Card',
    patientPortal: 'Patient Portal',
    fullName: 'Full Name',
    email: 'Email',
    ssn: 'Social Security',
    memberId: 'SAL Member ID',
    changePassword: 'Change Password',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmNewPassword: 'Confirm New Password',
    back: 'Back',
    save: 'Save',
    next: 'Next',
    contactInfo: 'Contact Info',
    primaryPhone: 'Primary Phone',
    mobilePhone: 'Mobile Phone',
    address: 'Address',
    address1: 'Address Line 1',
    address2: 'Address Line 2',
    city: 'City',
    postalCode: 'Postal Code',
    state: 'State',
    country: 'Country',
    preferences: 'Preferences',
    receiveEmailAlerts: 'Receive Email Alerts',
    receiveSmsNotifications: 'Receive SMS notifications',
    subscribeNewsletter: 'Subscribe to newsletter',
    profileData: 'Profile Data',
    dob: 'Date of Birth',
    height: 'Height (inches)',
    weight: 'Weight (pounds)',
    insurance: 'Insurance',
    policy: 'Policy',
    gender: 'Gender',
    selectGender: 'Select Gender',
    male: 'Male',
    female: 'Female',
    other: 'Other',
    bloodType: 'Blood Type',
    selectBloodType: 'Select Blood Type',
    countryOfBirth: 'Country of Birth',
    choose: 'Choose',
    nationality: 'Nationality',
    ethnicity: 'Ethnicity',
    white: 'White',
    black: 'Black',
    asian: 'Asian',
    hispanic: 'Hispanic',
    italian: 'Italian',
    middleEastern: 'Middle Eastern',
    pacificIslander: 'Pacific Islander',
    nativeAmerican: 'Native American',
    mixed: 'Mixed',
    specifyEthnicity: 'Specify ethnicity',
    specifyBloodType: 'Specify blood type',
    organDonor: 'Organ Donor',
    yes: 'Yes',
    no: 'No',
    emergencyContact: 'Emergency Contact',
    contactName: 'Contact Name',
    contactPhone: 'Contact Phone',
    relation: 'Relation',
    lifestyleInfo: 'Lifestyle Information',
    religion: 'Religion',
    placeOfWorship: 'Place of Worship',
    placeOfWorshipAddress: 'Place of Worship Address',
    enterPlaceOfWorship: 'Enter place of worship',
    church: 'Church',
    mosque: 'Mosque',
    temple: 'Temple',
    synagogue: 'Synagogue',
    gurdwara: 'Gurdwara',
    shrine: 'Shrine',
    chapel: 'Chapel',
    cathedral: 'Cathedral',
    monastery: 'Monastery',
    home: 'Home',
    communityCenter: 'Community Center',
    workAndHome: 'Work and Home',
    maritalStatus: 'Marital Status',
    single: 'Single',
    unmarried: 'Unmarried',
    married: 'Married',
    divorced: 'Divorced',
    widowed: 'Widowed',
    separated: 'Separated',
    workStatus: 'Work Status',
    employed: 'Employed',
    selfEmployed: 'Self-Employed',
    unemployed: 'Unemployed',
    retired: 'Retired',
    student: 'Student',
    education: 'Education',
    noFormalEducation: 'No Formal Education',
    primarySchool: 'Primary School',
    secondarySchool: 'Secondary School',
    none: 'None',
    highSchool: 'High School',
    associateDegree: 'Associate Degree',
    bachelorDegree: 'Bachelor\'s Degree',
    bachelor: 'Bachelor Degree',
    masterDegree: 'Master\'s Degree',
    graduate: 'Graduate Degree',
    doctorate: 'Doctorate',
    occupation: 'Occupation',
    engineer: 'Engineer',
    teacher: 'Teacher',
    doctor: 'Doctor',
    nurse: 'Nurse',
    lawyer: 'Lawyer',
    business: 'Business',
    exerciseAndDiet: 'Exercise and Diet',
    dietaryRoutine: 'Dietary Routine',
    omnivore: 'Omnivore',
    balanced: 'Balanced',
    vegetarian: 'Vegetarian',
    vegan: 'Vegan',
    pescatarian: 'Pescatarian',
    keto: 'Keto',
    paleo: 'Paleo',
    mediterranean: 'Mediterranean',
    glutenFree: 'Gluten-Free',
    dairyFree: 'Dairy-Free',
    exerciseFrequency: 'Exercise Frequency',
    never: 'Never',
    rarely: 'Rarely',
    occasionally: 'Occasionally',
    regularly: 'Regularly',
    daily: 'Daily',
    oneToTwoTimesPerWeek: '1-2 Times Per Week',
    threeToFourTimesPerWeek: '3-4 Times Per Week',
    fivePlusTimesPerWeek: '5+ Times Per Week',
    catholic: 'Catholic',
    protestant: 'Protestant',
    orthodox: 'Orthodox',
    baptist: 'Baptist',
    methodist: 'Methodist',
    lutheran: 'Lutheran',
    presbyterian: 'Presbyterian',
    episcopal: 'Episcopal',
    christianity: 'Christianity',
    islam: 'Islam',
    hinduism: 'Hinduism',
    buddhism: 'Buddhism',
    judaism: 'Judaism',
    sikhism: 'Sikhism',
    pleaseSpecify: 'Please specify',
    enterCustomReligion: 'Enter your religion',
    findDoctor: 'Find a Doctor',
    findDoctorPlaceholder: 'Find a Doctor',
    selectedDoctor: 'Selected Doctor',
    doctorName: 'Name',
    serviceProvided: 'Service Provided',
    npiNumber: 'NPI Number',
    credential: 'Credential',
    specialty: 'Specialty',
    gender: 'Gender',
    salId: 'SAL ID',
    phone: 'Phone',
    email: 'Email',
    myDoctors: 'My Doctors',
    searchPlaceholder: 'Search',
    allStatuses: 'All Statuses',
    active: 'Active',
    inactive: 'Inactive',
    role: 'Role',
    actions: 'Actions',
    noDoctorsFound: 'No doctors found.',
    cardiologist: 'Cardiologist',
    cardiology: 'Cardiology',
    neurology: 'Neurology',
    orthopedics: 'Orthopedics',
    pediatrics: 'Pediatrics',
    generalPractice: 'General Practice',
    clinicsAndHospitals: 'Clinics and Hospitals',
    findHospitalPlaceholder: 'Find a Hospital',
    currentInstitution: 'Current Institution',
    hospitalName: 'Name',
    medicalServiceProvided: 'Medical Service Provided',
    hospitalGeneral: 'Hospital-General',
    hospitalSpecialty: 'Hospital-Specialty',
    rehabilitation: 'Rehabilitation',
    surgeryCenter: 'Surgery Center',
    myInstitutions: 'My Institutions',
    noInstitutionsFound: 'No institutions found.',
    fileUpload: 'File Upload',
    categoryFolder: 'Category (Folder)',
    title: 'Title',
    detailsNotes: 'Details / Notes',
    file: 'File',
    type: 'Type',
    size: 'Size',
    created: 'Created',
    updated: 'Updated',
    new: 'New',
    myRecords: 'My Records',
    noRecordsFound: 'No records found.',
    pleaseSelectFile: 'Please select a file to upload',
    pleaseSelectCategory: 'Please select a category',
    pleaseEnterTitle: 'Please enter a title',
    documentSaved: 'Document saved successfully!',
    documentDeleted: 'Document deleted successfully!',
    deleteDocument: 'Delete Document',
    confirmDeleteDocument: 'Are you sure you want to delete',
    actionCannotBeUndone: 'This action cannot be undone.',
    deleting: 'Deleting...',
    clickToUpload: 'Click to Upload',
    orDragAndDrop: 'or drag and drop',
    labResults: 'Lab Results',
    imaging: 'Imaging',
    medicineSupplements: 'Medicine & Supplements',
    searchMedications: 'Search Medications',
    searchMedicationPlaceholder: 'Search for Medication',
    dosage: 'Dosage',
    selectDosage: 'Select Dosage',
    myMedications: 'My Medications',
    noMedicationsFound: 'No medications found.',
    addDetails: 'Add Details',
    medicalConditions: 'Medical Conditions',
    searchConditions: 'Search Conditions',
    searchConditionsPlaceholder: 'Search for Conditions',
    alias: 'Alias',
    moreInfo: 'More Info',
    notesDetails: 'Notes / Details',
    myConditions: 'My Conditions',
    noConditionsFound: 'No conditions found.',
    noConditionsFoundSearch: 'No conditions found for "{searchTerm}"',
    medicalProcedures: 'Medical Procedures',
    searchProcedures: 'Search Procedures',
    searchProceduresPlaceholder: 'Enter procedure name',
    fullName: 'Full Name',
    medicalCode: 'Medical Code',
    medicalCodeDotted: 'Medical Code Dotted',
    detailsNotes: 'Details / Notes',
    addNotesDetails: 'Add Notes / Details',
    myProcedures: 'My Procedures',
    noProceduresFound: 'No procedures found.',
    knownAllergies: 'Known Allergies',
    allergy: 'Allergy',
    enterAllergy: 'Enter Allergy',
    myAllergies: 'My Allergies',
    noAllergiesFound: 'No allergies found.',
    // Additions for HistoryPage
    familyHistoryMedicalConditions: 'Family History Medical Conditions',
    chooseRelation: 'Choose Relationship',
    brother: 'Brother',
    sister: 'Sister',
    mother: 'Mother',
    father: 'Father',
    paternalGrandmother: 'Paternal Grandmother',
    maternalGrandmother: 'Maternal Grandmother',
    paternalGrandfather: 'Paternal Grandfather',
    maternalGrandfather: 'Maternal Grandfather',
    maternalAunt: 'Maternal Aunt',
    paternalAunt: 'Paternal Aunt',
    maternalUncle: 'Maternal Uncle',
    paternalUncle: 'Paternal Uncle',
    myChronicles: 'My Chronicles',
    noChroniclesFound: 'No chronicles found.',
    cardRender: 'Card Render',
    printCard: 'Print Card',
    download: 'Download',
    pharmacy: 'Pharmacy',
    signupTitle: 'Sign Up',
    signupName: 'Name',
    signupEmail: 'Email',
    signupPassword: 'Password',
    signupRole: 'Role',
    signupSelectRole: 'Select Role',
    signupDoctor: 'Doctor',
    signupPatient: 'Patient',
    signupButton: 'Sign Up',
    signupAlreadyAccount: 'Already have an account?',
    signupLogin: 'Login',
    signupErrorRequired: 'Please fill in all fields.',
    signupErrorTerms: 'Please accept the terms and conditions to continue',
    loginTitle: 'Login',
    loginEmail: 'Email',
    loginPassword: 'Password',
    loginButton: 'Login',
    loginErrorRequired: 'Please fill in all fields.',
    loginNoAccount: "Don't have an account?",
    loginSignup: 'Sign Up',
    doctorPortal: 'Doctor Portal',
    documentName: 'Name',
    format: 'Format',
    category: 'Category',
    medicationName: 'Name',
    url: 'URL',
    dotted: 'Dotted',
    tableName: 'Name',
    tableDetails: 'Details',
    tableActions: 'Actions',
    familyRelation: 'Family Relation',
    tableAlias: 'Alias',
    tableUrl: 'Url',
    tableRole: 'Role',
    // HistoryPage table headers
    tableCondition: 'Condition',
    tableRelation: 'Relation',
    tableMoreInfo: 'More Info',
    tableStatus: 'Status',
    edit: 'Edit',
    delete: 'Delete',
    editCondition: 'Edit Medical Condition',
    updateCondition: 'Update Condition',
    addCondition: 'Add Condition',
    pleaseFillRequiredFields: 'Please fill in all required fields',
    confirmDelete: 'Are you sure you want to delete this condition?',
    validationError: 'Validation Error',
    ok: 'OK',
    deleteConditionWarning: 'Are you sure you want to delete this condition? This action cannot be undone.',
    addConditionToHistory: 'Add condition to family history',
    // CreateCardModal translations
    createYourCard: 'Create your card',
    allergies: 'Allergies',
    medications: 'Medications',
    conditions: 'Conditions',
    hospitals: 'Hospitals',
    doctors: 'Doctors',
    hospital: 'Hospital',
    doctor: 'Doctor',
    contact: 'Contact',
    primaryPhone: 'Primary Phone Number',
    secondaryPhone: 'Secondary Phone Number',
    secondaryMobile: 'Secondary Mobile Number',
    primaryInsurance: 'Primary Insurance',
    secondaryInsurance: 'Secondary Insurance',
    addPrimaryInsurance: 'Add primary insurance',
    addSecondaryInsurance: 'Add secondary insurance',
    selectInsurance: 'Select Insurance',
    enterOtherInsurance: 'Enter other insurance',
    primaryInsuranceMemberId: 'Primary Insurance Member ID',
    secondaryInsuranceMemberId: 'Secondary Insurance Member ID',
    enterPrimaryMemberId: 'Enter primary insurance member ID',
    enterSecondaryMemberId: 'Enter secondary insurance member ID',
    lifeInsurance: 'Life Insurance',
    disabilityInsurance: 'Disability Insurance',
    lifeInsuranceMemberId: 'Life Insurance Member ID',
    disabilityInsuranceMemberId: 'Disability Insurance Member ID',
    lifeInsuranceAmount: 'Life Insurance Amount ($)',
    disabilityInsuranceAmount: 'Disability Insurance Amount ($)',
    enterLifeMemberId: 'Enter life insurance member ID',
    enterDisabilityMemberId: 'Enter disability insurance member ID',
    enterLifeAmount: 'Enter life insurance amount ($)',
    enterDisabilityAmount: 'Enter disability insurance amount ($)',
    insuranceState: 'State',
    enterState: 'Enter state',
    organDonor: 'Organ Donor',
    selectBloodType: 'Select Blood Type',
    dateOfBirth: 'Date of Birth',
    ssn: 'SSN',
    ekg: 'EKG',
    submit: 'Submit',
    searching: 'Searching',
    addAllergy: 'Add allergy',
    addMedication: 'Add medication manually',
    addCondition: 'Add condition manually',
    addHospital: 'Add hospital',
    hospitalCity: 'Hospital City',
    hospitalZipCode: 'ZIP Code',
    enterHospitalCity: 'Enter hospital city',
    enterHospitalZipCode: 'Enter ZIP code',
    addDoctor: 'Add doctor manually',
    searchMedications: 'Or search medications',
    searchConditions: 'Or search conditions',
    searchHospitals: 'Or search hospitals',
    searchDoctors: 'Or search doctors',
    noHospitalsFound: 'No hospitals found for "{searchTerm}"',
    noDoctorsFound: 'No doctors found for "{searchTerm}"',

    noMedicationsFound: 'No medications found for "{searchTerm}"',
    noResultsFound: 'No results found for "{searchTerm}"',
    tryDifferentSearch: 'Try a different search term or check spelling',
    // Doctor Dashboard translations
    doctorDashboard: 'Doctor Dashboard',
    doctorDashboardDescription: 'Manage your patients and their medical records with ease. Add new patients, view their information, and keep track of their health data.',
    addNewPatient: 'Add New Patient',
    totalPatients: 'Total Patients',
    activePatients: 'Active Patients',
    inactivePatients: 'Inactive Patients',
    currentlyActive: 'Currently Active',
    currentlyInactive: 'Currently Inactive',
    thisMonth: 'This Month',
    searchPatientsPlaceholder: 'Search patients by name, email, or member ID',
    allPatients: 'All Patients',
    patientList: 'Patient List',
    patient: 'patient',
    patients: 'patients',
    noPatientsFound: 'No patients found',
    tryAdjustingSearch: 'Try adjusting your search terms or filters.',
    getStartedMessage: 'Get started by adding your first patient to begin managing their health records.',
    addYourFirstPatient: 'Add Your First Patient',
    memberId: 'Member ID',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    actions: 'Actions',
    viewPatientDetails: 'View Patient Details',
    editPatient: 'Edit Patient',
    deletePatient: 'Delete Patient',
    showingResults: 'Showing',
    to: 'to',
    of: 'of',
    previous: 'Previous',
    next: 'Next',
    sortBy: 'Sort by',
    nameAZ: 'Name (A-Z)',
    nameZA: 'Name (Z-A)',
    emailAZ: 'Email (A-Z)',
    emailZA: 'Email (Z-A)',
    memberIdAZ: 'Member ID (A-Z)',
    memberIdZA: 'Member ID (Z-A)',
    statusActiveFirst: 'Status (Active First)',
    statusInactiveFirst: 'Status (Inactive First)',
    accountInformation: 'Account Information',
    contactInformation: 'Contact Information',
    profileInformation: 'Profile Information',
    emergencyContact: 'Emergency Contact',
    lifestyleInformation: 'Lifestyle Information',
    preferences: 'Preferences',
    receiveEmailAlerts: 'Receive Email Alerts',
    receiveSmsNotifications: 'Receive Text Messages',
    subscribeToNewsletter: 'Subscribe to Newsletter',
    cancel: 'Cancel',
    close: 'Close',
    updatePatient: 'Update Patient',
    addPatient: 'Add Patient',
    patientDetails: 'Patient Details',
    medicalInformation: 'Medical Information',
    deletePatientConfirmation: 'Are you sure you want to delete',
    deletePatientWarning: 'This action cannot be undone and will permanently remove all patient data.',
    createCardErrorRequired: 'Please fill in all required fields.',
    creatingCard: 'Creating Card...',
    // Field validation errors
    allergiesRequired: 'At least one allergy is required',
    medicationsRequired: 'At least one medication is required',
    conditionsRequired: 'At least one condition is required',
    hospitalsRequired: 'At least one hospital is required',
    doctorsRequired: 'At least one doctor is required',
    primaryPhoneRequired: 'Primary Phone Number is required',
    secondaryPhoneRequired: 'Secondary Phone Number is required',
    secondaryMobileRequired: 'Secondary Mobile Number is required',
    religionRequired: 'Religion is required',
    ekgRequired: 'EKG is required',
    bloodTypeRequired: 'Blood Type is required',
    dobRequired: 'Date of Birth is required',
    ssnRequired: 'SSN is required',
    invalidPhoneNumber: 'Please enter a valid phone number',
    invalidMobileNumber: 'Please enter a valid mobile number',
    invalidDateFormat: 'Please enter a valid date in MM/DD/YYYY format',
    dateInFuture: 'Date of Birth cannot be in the future',
    dateInvalid: 'Please enter a valid Date of Birth',
    invalidSSNFormat: 'Please enter a valid SSN format (XXX-XX-XXXX)',
    // API error messages
    validationError: 'Validation Error',
    primaryPhoneInvalid: 'Primary phone number is invalid',
    bloodTypeInvalid: 'Blood type is invalid',
    dateOfBirthInvalid: 'Date of birth is invalid',
    ssnInvalid: 'SSN is invalid',
    // Field specific errors
    allergiesEmpty: 'Allergies list cannot be empty',
    medicationsEmpty: 'Medications list cannot be empty',
    conditionsEmpty: 'Conditions list cannot be empty',
    hospitalsEmpty: 'Hospitals list cannot be empty',
    doctorsEmpty: 'Doctors list cannot be empty',
    // Additional validation messages
    phoneNumberFormat: 'Phone number format should be XXX-XXX-XXXX',
    mobileNumberFormat: 'Mobile number format should be XXX-XXX-XXXX',
    dobFormat: 'Date format should be MM/DD/YYYY',
    dobFutureDate: 'Date of birth cannot be a future date',
    dobTooOld: 'Date of birth appears to be too old',
    ssnFormat: 'SSN format should be XXX-XX-XXXX',
    religionEmpty: 'Please select a religion',
    ekgEmpty: 'EKG field cannot be empty',
    // Verification Modal translations
    verifyEmail: 'Verify Your Email',
    verificationDescription: 'We\'ve sent a 4-digit verification code to',
    enterVerificationCode: 'Enter Verification Code',
    resendIn: 'Resend code in',
    resendCode: 'Resend Code',
    verifying: 'Verifying...',
    verificationHelp: 'Didn\'t receive the code? Check your spam folder or try resending.',
    verificationCodeRequired: 'Please enter a valid 4-digit verification code',
    verificationFailed: 'Verification failed. Please try again.',
    resendFailed: 'Failed to resend code. Please try again.',
  },
  es: {
    welcome: '¡Bienvenido!',
    portalDesc: 'Este es su portal privado de paciente. Administre su cuenta y datos aquí.',
    dashboard: 'Tablero',
    gotoDashboard: 'Ir al Tablero',
    close: 'Cerrar',
    logout: 'Cerrar sesión',
    account: 'Cuenta',
    accountDesc: 'Vea y actualice los datos y preferencias de su cuenta',
    manageAccount: 'Administrar cuenta',
    contact: 'Contacto',
    contactDesc: 'Actualice sus datos de contacto y dirección',
    manageContacts: 'Administrar contactos',
    primaryPhoneNumber: 'Número de Teléfono Principal',
    secondaryPhoneNumber: 'Número de Teléfono Secundario',
    secondaryMobileNumber: 'Número de Móvil Secundario',
    bloodType: 'Tipo de Sangre',
    dateOfBirth: 'Fecha de Nacimiento',
    ssn: 'Número de Seguro Social',
    ekg: 'ECG',
    profile: 'Perfil',
    profileDesc: 'Gestione su perfil y datos personales básicos',
    profileDetails: 'Detalles del perfil',
    lifestyle: 'Estilo de vida',
    lifestyleDesc: 'Los detalles sobre sus rutinas son útiles en una emergencia',
    dayToDay: 'Su día a día',
    yourDayToDay: 'Su día a día',
    physiciansAndSpecialists: 'Médicos y Especialistas',
    hospitalsAndClinics: 'Hospitales y Clínicas',
    prescriptionsAndSupplements: 'Recetas y Suplementos',
    injuriesAndIllnesses: 'Lesiones y Enfermedades',
    surgeriesTherapy: 'Cirugías y Terapia',
    familyMedicalHistory: 'Historia Médica Familiar',
    salMineCard: 'Tarjeta SAL Mine',
    doctors: 'Doctores',
    doctorsDesc: 'Comparta datos con sus médicos de servicio',
    physicians: 'Médicos y especialistas',
    hospitals: 'Hospitales',
    hospitalsDesc: 'Comparta datos con sus instituciones médicas',
    hospitalsClinics: 'Hospitales y clínicas',
    documents: 'Documentos',
    documentsDesc: 'Cargue sus registros médicos y gestione el acceso',
    manageRecords: 'Administrar registros',
    medications: 'Medicamentos',
    medicationsDesc: 'Cuéntenos sobre sus medicamentos y suplementos',
    prescriptions: 'Recetas y suplementos',
    conditions: 'Condiciones',
    conditionsDesc: 'Cuéntenos sobre lesiones, enfermedades y accidentes',
    injuries: 'Lesiones y enfermedades',
    procedures: 'Procedimientos',
    proceduresDesc: 'Cuéntenos sobre los procedimientos médicos que ha realizado',
    surgeries: 'Cirugías, terapia',
    therapyTreatment: 'Terapia y Tratamiento',
    addTherapy: 'Agregar Terapia/Tratamiento',
    myTherapies: 'Mis Terapias',
    frequency: 'Frecuencia',
    duration: 'Duración',
    description: 'Descripción',
    medicalDevices: 'Dispositivos Médicos',
    addDevice: 'Agregar Dispositivo Médico',
    myDevices: 'Mis Dispositivos Médicos',
    deviceName: 'Nombre del Dispositivo',
    deviceType: 'Tipo de Dispositivo',
    brand: 'Marca',
    model: 'Modelo',
    allergies: 'Alergias',
    allergiesDesc: 'Cuéntenos sobre lo que su cuerpo no tolera',
    allergens: 'Alérgenos',
    history: 'Historia',
    historyDesc: 'Información de salud sobre familiares cercanos',
    familyHistory: 'Historia médica familiar',
    salCard: 'Tarjeta SAL Mine',
    salCardDesc: 'Ver, ordenar o imprimir su tarjeta SAL Mine',
    patientPortal: 'Portal del Paciente',
    fullName: 'Nombre completo',
    email: 'Correo electrónico',
    ssn: 'Seguro Social',
    memberId: 'ID de miembro SAL',
    changePassword: 'Cambiar contraseña',
    currentPassword: 'Contraseña actual',
    newPassword: 'Nueva contraseña',
    confirmNewPassword: 'Confirmar nueva contraseña',
    back: 'Atrás',
    save: 'Guardar',
    next: 'Siguiente',
    contactInfo: 'Información de contacto',
    primaryPhone: 'Teléfono principal',
    mobilePhone: 'Teléfono móvil',
    address: 'Dirección',
    address1: 'Dirección línea 1',
    address2: 'Dirección línea 2',
    city: 'Ciudad',
    postalCode: 'Código postal',
    state: 'Estado',
    country: 'País',
    preferences: 'Preferencias',
    receiveEmailAlerts: 'Recibir alertas por correo electrónico',
    receiveSmsNotifications: 'Recibir mensajes de texto',
    subscribeNewsletter: 'Suscribirse al boletín',
    profileData: 'Datos del perfil',
    dob: 'Fecha de nacimiento',
    height: 'Altura (pulgadas)',
    weight: 'Peso (libras)',
    insurance: 'Seguro',
    policy: 'Póliza',
    gender: 'Género',
    selectGender: 'Seleccionar género',
    male: 'Masculino',
    female: 'Femenino',
    other: 'Otro',
    bloodType: 'Tipo de sangre',
    selectBloodType: 'Seleccionar tipo de sangre',
    countryOfBirth: 'País de nacimiento',
    choose: 'Elegir',
    nationality: 'Nacionalidad',
    ethnicity: 'Etnicidad',
    white: 'Blanco',
    black: 'Negro',
    asian: 'Asiático',
    hispanic: 'Hispano',
    italian: 'Italiano',
    middleEastern: 'Medio Oriente',
    pacificIslander: 'Isleño del Pacífico',
    nativeAmerican: 'Nativo Americano',
    mixed: 'Mixto',
    specifyEthnicity: 'Especificar etnicidad',
    specifyBloodType: 'Especificar tipo de sangre',
    organDonor: 'Donante de órganos',
    yes: 'Sí',
    no: 'No',
    emergencyContact: 'Contacto de emergencia',
    contactName: 'Nombre del contacto',
    contactPhone: 'Teléfono del contacto',
    relation: 'Relación',
    lifestyleInfo: 'Información de estilo de vida',
    religion: 'Religión',
    placeOfWorship: 'Lugar de culto',
    placeOfWorshipAddress: 'Dirección del lugar de culto',
    enterPlaceOfWorship: 'Ingrese lugar de culto',
    church: 'Iglesia',
    mosque: 'Mezquita',
    temple: 'Templo',
    synagogue: 'Sinagoga',
    gurdwara: 'Gurdwara',
    shrine: 'Santuario',
    chapel: 'Capilla',
    cathedral: 'Catedral',
    monastery: 'Monasterio',
    home: 'Casa',
    communityCenter: 'Centro Comunitario',
    workAndHome: 'Trabajo y hogar',
    maritalStatus: 'Estado civil',
    single: 'Soltero/a',
    unmarried: 'Soltero/a',
    married: 'Casado/a',
    divorced: 'Divorciado/a',
    widowed: 'Viudo/a',
    separated: 'Separado/a',
    workStatus: 'Situación laboral',
    employed: 'Empleado',
    selfEmployed: 'Autónomo',
    unemployed: 'Desempleado',
    retired: 'Jubilado',
    student: 'Estudiante',
    education: 'Educación',
    noFormalEducation: 'Sin educación formal',
    primarySchool: 'Escuela primaria',
    secondarySchool: 'Escuela secundaria',
    none: 'Ninguna',
    highSchool: 'Escuela secundaria',
    associateDegree: 'Título de asociado',
    bachelorDegree: 'Licenciatura',
    bachelor: 'Licenciatura',
    masterDegree: 'Maestría',
    graduate: 'Posgrado',
    doctorate: 'Doctorado',
    occupation: 'Ocupación',
    engineer: 'Ingeniero',
    teacher: 'Profesor',
    doctor: 'Médico',
    nurse: 'Enfermero/a',
    lawyer: 'Abogado/a',
    business: 'Negocios',
    exerciseAndDiet: 'Ejercicio y dieta',
    dietaryRoutine: 'Rutina alimentaria',
    omnivore: 'Omnívoro',
    balanced: 'Equilibrada',
    vegetarian: 'Vegetariana',
    vegan: 'Vegana',
    pescatarian: 'Pescetariano',
    keto: 'Keto',
    paleo: 'Paleo',
    mediterranean: 'Mediterránea',
    glutenFree: 'Sin Gluten',
    dairyFree: 'Sin Lácteos',
    exerciseFrequency: 'Frecuencia de ejercicio',
    never: 'Nunca',
    rarely: 'Raramente',
    occasionally: 'Ocasionalmente',
    regularly: 'Regularmente',
    daily: 'Diario',
    oneToTwoTimesPerWeek: '1-2 Veces Por Semana',
    threeToFourTimesPerWeek: '3-4 Veces Por Semana',
    fivePlusTimesPerWeek: '5+ Veces Por Semana',
    catholic: 'Católico',
    protestant: 'Protestante',
    orthodox: 'Ortodoxo',
    baptist: 'Bautista',
    methodist: 'Metodista',
    lutheran: 'Luterano',
    presbyterian: 'Presbiteriano',
    episcopal: 'Episcopal',
    christianity: 'Cristianismo',
    islam: 'Islam',
    hinduism: 'Hinduismo',
    buddhism: 'Budismo',
    judaism: 'Judaísmo',
    sikhism: 'Sijismo',
    findDoctor: 'Buscar un doctor',
    findDoctorPlaceholder: 'Buscar un doctor',
    selectedDoctor: 'Doctor seleccionado',
    doctorName: 'Nombre',
    serviceProvided: 'Servicio proporcionado',
    npiNumber: 'Número NPI',
    credential: 'Credencial',
    specialty: 'Especialidad',
    gender: 'Género',
    salId: 'ID SAL',
    phone: 'Teléfono',
    email: 'Correo electrónico',
    myDoctors: 'Mis doctores',
    searchPlaceholder: 'Buscar',
    allStatuses: 'Todos los estados',
    active: 'Activo',
    inactive: 'Inactivo',
    role: 'Rol',
    actions: 'Acciones',
    noDoctorsFound: 'No se encontraron doctores.',
    cardiologist: 'Cardiólogo',
    cardiology: 'Cardiología',
    neurology: 'Neurología',
    orthopedics: 'Ortopedia',
    pediatrics: 'Pediatría',
    generalPractice: 'Práctica general',
    clinicsAndHospitals: 'Clínicas y hospitales',
    findHospitalPlaceholder: 'Buscar un hospital',
    currentInstitution: 'Institución actual',
    hospitalName: 'Nombre',
    medicalServiceProvided: 'Servicio médico proporcionado',
    hospitalGeneral: 'Hospital general',
    hospitalSpecialty: 'Hospital especializado',
    rehabilitation: 'Rehabilitación',
    surgeryCenter: 'Centro de cirugía',
    myInstitutions: 'Mis instituciones',
    noInstitutionsFound: 'No se encontraron instituciones.',
    fileUpload: 'Subir archivo',
    categoryFolder: 'Categoría (carpeta)',
    title: 'Título',
    detailsNotes: 'Detalles / Notas',
    file: 'Archivo',
    type: 'Tipo',
    size: 'Tamaño',
    created: 'Creado',
    updated: 'Actualizado',
    new: 'Nuevo',
    myRecords: 'Mis registros',
    noRecordsFound: 'No se encontraron registros.',
    pleaseSelectFile: 'Por favor seleccione un archivo para subir',
    pleaseSelectCategory: 'Por favor seleccione una categoría',
    pleaseEnterTitle: 'Por favor ingrese un título',
    documentSaved: '¡Documento guardado exitosamente!',
    documentDeleted: '¡Documento eliminado exitosamente!',
    deleteDocument: 'Eliminar Documento',
    confirmDeleteDocument: '¿Está seguro de que desea eliminar',
    actionCannotBeUndone: 'Esta acción no se puede deshacer.',
    deleting: 'Eliminando...',
    clickToUpload: 'Haga clic para subir',
    orDragAndDrop: 'o arrastre y suelte',
    labResults: 'Resultados de laboratorio',
    imaging: 'Imágenes',
    medicineSupplements: 'Medicamentos y suplementos',
    searchMedications: 'Buscar medicamentos',
    searchMedicationPlaceholder: 'Buscar medicamento',
    dosage: 'Dosis',
    selectDosage: 'Seleccionar dosis',
    myMedications: 'Mis medicamentos',
    noMedicationsFound: 'No se encontraron medicamentos.',
    addDetails: 'Agregar detalles',
    medicalConditions: 'Condiciones médicas',
    searchConditions: 'Buscar condiciones',
    searchConditionsPlaceholder: 'Buscar condiciones',
    alias: 'Alias',
    moreInfo: 'Más información',
    notesDetails: 'Notas / Detalles',
    myConditions: 'Mis condiciones',
    noConditionsFound: 'No se encontraron condiciones.',
    noConditionsFoundSearch: 'No se encontraron condiciones para "{searchTerm}"',
    medicalProcedures: 'Procedimientos médicos',
    searchProcedures: 'Buscar procedimientos',
    searchProceduresPlaceholder: 'Buscar procedimientos',
    fullName: 'Nombre completo',
    medicalCode: 'Código médico',
    medicalCodeDotted: 'Código médico punteado',
    detailsNotes: 'Detalles / Notas',
    addNotesDetails: 'Agregar notas / detalles',
    myProcedures: 'Mis procedimientos',
    noProceduresFound: 'No se encontraron procedimientos.',
    knownAllergies: 'Alergias conocidas',
    allergy: 'Alergia',
    enterAllergy: 'Ingrese alergia',
    myAllergies: 'Mis alergias',
    noAllergiesFound: 'No se encontraron alergias.',
    // Additions for HistoryPage (Spanish)
    familyHistoryMedicalConditions: 'Condiciones médicas familiares',
    chooseRelation: 'Elegir relación',
    brother: 'Hermano',
    sister: 'Hermana',
    mother: 'Madre',
    father: 'Padre',
    paternalGrandmother: 'Abuela Paterna',
    maternalGrandmother: 'Abuela Materna',
    paternalGrandfather: 'Abuelo Paterno',
    maternalGrandfather: 'Abuelo Materno',
    maternalAunt: 'Tía Materna',
    paternalAunt: 'Tía Paterna',
    maternalUncle: 'Tío Materno',
    paternalUncle: 'Tío Paterno',
    myChronicles: 'Mis crónicas',
    noChroniclesFound: 'No se encontraron crónicas.',
    cardRender: 'Renderizado de tarjeta',
    printCard: 'Imprimir tarjeta',
    download: 'Descargar',
    pharmacy: 'Farmacia',
    signupTitle: 'Registrarse',
    signupName: 'Nombre',
    signupEmail: 'Correo electrónico',
    signupPassword: 'Contraseña',
    signupRole: 'Rol',
    signupSelectRole: 'Seleccionar rol',
    signupDoctor: 'Doctor',
    signupPatient: 'Paciente',
    signupButton: 'Registrarse',
    signupAlreadyAccount: '¿Ya tienes una cuenta?',
    signupLogin: 'Iniciar sesión',
    signupErrorRequired: 'Por favor, complete todos los campos.',
    signupErrorTerms: 'Por favor, acepte los términos y condiciones para continuar',
    loginTitle: 'Iniciar sesión',
    loginEmail: 'Correo electrónico',
    loginPassword: 'Contraseña',
    loginButton: 'Iniciar sesión',
    loginErrorRequired: 'Por favor, complete todos los campos.',
    loginNoAccount: '¿No tienes una cuenta?',
    loginSignup: 'Registrarse',
    doctorPortal: 'Portal del Doctor',
    documentName: 'Nombre',
    format: 'Formato',
    category: 'Categoría',
    medicationName: 'Nombre',
    url: 'URL',
    dotted: 'Punteado',
    tableName: 'Nombre',
    tableDetails: 'Detalles',
    tableActions: 'Acciones',
    familyRelation: 'Relación familiar',
    tableAlias: 'Alias',
    tableUrl: 'Url',
    tableRole: 'Rol',
    // HistoryPage table headers
    tableCondition: 'Condición',
    tableRelation: 'Relación',
    tableMoreInfo: 'Más información',
    tableStatus: 'Estado',
    edit: 'Editar',
    delete: 'Eliminar',
    editCondition: 'Editar condición médica',
    updateCondition: 'Actualizar condición',
    addCondition: 'Agregar condición',
    pleaseFillRequiredFields: 'Por favor, complete todos los campos requeridos',
    confirmDelete: '¿Está seguro de que desea eliminar esta condición?',
    validationError: 'Error de validación',
    ok: 'OK',
    deleteConditionWarning: '¿Está seguro de que desea eliminar esta condición? Esta acción no se puede deshacer.',
    addConditionToHistory: 'Agregar condición a la historia familiar',
    // CreateCardModal translations
    createYourCard: 'Crear su tarjeta',
    allergies: 'Alergias',
    medications: 'Medicamentos',
    conditions: 'Condiciones',
    hospitals: 'Hospitales',
    doctors: 'Doctores',
    hospital: 'Hospital',
    doctor: 'Doctor',
    contact: 'Contacto',
    primaryPhone: 'Número de Teléfono Primario',
    secondaryPhone: 'Número de Teléfono Secundario',
    secondaryMobile: 'Número de Móvil Secundario',
    primaryInsurance: 'Seguro Primario',
    secondaryInsurance: 'Seguro Secundario',
    addPrimaryInsurance: 'Agregar seguro primario',
    addSecondaryInsurance: 'Agregar seguro secundario',
    selectInsurance: 'Seleccionar Seguro',
    enterOtherInsurance: 'Ingrese otro seguro...',
    primaryInsuranceMemberId: 'ID de Miembro del Seguro Primario',
    secondaryInsuranceMemberId: 'ID de Miembro del Seguro Secundario',
    enterPrimaryMemberId: 'Ingrese ID de miembro del seguro primario',
    enterSecondaryMemberId: 'Ingrese ID de miembro del seguro secundario',
    lifeInsurance: 'Seguro de Vida',
    disabilityInsurance: 'Seguro de Incapacidad',
    lifeInsuranceMemberId: 'ID de Miembro del Seguro de Vida',
    disabilityInsuranceMemberId: 'ID de Miembro del Seguro de Incapacidad',
    lifeInsuranceAmount: 'Monto del Seguro de Vida',
    disabilityInsuranceAmount: 'Monto del Seguro de Incapacidad',
    enterLifeMemberId: 'Ingrese ID del seguro de vida',
    enterDisabilityMemberId: 'Ingrese ID del seguro de incapacidad',
    enterLifeAmount: 'Ingrese monto del seguro de vida',
    enterDisabilityAmount: 'Ingrese monto del seguro de incapacidad',
    insuranceState: 'Estado',
    enterState: 'Ingrese estado',
    organDonor: 'Donante de órganos',
    selectBloodType: 'Seleccionar tipo de sangre',
    dateOfBirth2: 'MM/DD/YYYY',
    ssn: 'SSN',
    ekg: 'ECG',
    submit: 'Enviar',
    searching: 'Buscando',
    addAllergy: 'Agregar alergia',
    addMedication: 'Agregar medicamento manualmente',
    addCondition: 'Agregar condición manualmente',
    addHospital: 'Agregar hospital',
    addDoctor: 'Agregar doctor manualmente',
    searchMedications: 'O buscar medicamentos',
    searchConditions: 'O buscar condiciones',
    searchHospitals: 'O buscar hospitales',
    searchDoctors: 'O buscar doctores',
    noHospitalsFound: 'No se encontraron hospitales para "{searchTerm}"',
    noDoctorsFound: 'No se encontraron doctores para "{searchTerm}"',

    noMedicationsFound: 'No se encontraron medicamentos para "{searchTerm}"',
    noResultsFound: 'No se encontraron resultados para "{searchTerm}"',
    tryDifferentSearch: 'Intente un término de búsqueda diferente o revise la ortografía',
    pleaseSpecify: 'Por favor, especifique',
    enterCustomReligion: 'Ingrese su religión', 
    // Doctor Dashboard translations (Spanish)
    doctorDashboard: 'Panel del Doctor',
    doctorDashboardDescription: 'Administre sus pacientes y sus registros médicos con facilidad. Agregue nuevos pacientes, vea su información y mantenga un seguimiento de sus datos de salud.',
    addNewPatient: 'Agregar Nuevo Paciente',
    totalPatients: 'Total de Pacientes',
    activePatients: 'Pacientes Activos',
    inactivePatients: 'Pacientes Inactivos',
    currentlyActive: 'Actualmente Activo',
    currentlyInactive: 'Actualmente Inactivo',
    thisMonth: 'Este Mes',
    searchPatientsPlaceholder: 'Buscar pacientes por nombre, correo electrónico o ID de miembro',
    allPatients: 'Todos los Pacientes',
    patientList: 'Lista de Pacientes',
    patient: 'paciente',
    patients: 'pacientes',
    noPatientsFound: 'No se encontraron pacientes',
    tryAdjustingSearch: 'Intente ajustar sus términos de búsqueda o filtros.',
    getStartedMessage: 'Comience agregando su primer paciente para comenzar a administrar sus registros de salud.',
    addYourFirstPatient: 'Agregar Su Primer Paciente',
    memberId: 'ID de Miembro',
    status: 'Estado',
    active: 'Activo',
    inactive: 'Inactivo',
    actions: 'Acciones',
    viewPatientDetails: 'Ver Detalles del Paciente',
    editPatient: 'Editar Paciente',
    deletePatient: 'Eliminar Paciente',
    showingResults: 'Mostrando',
    to: 'a',
    of: 'de',
    previous: 'Anterior',
    next: 'Siguiente',
    sortBy: 'Ordenar por',
    nameAZ: 'Nombre (A-Z)',
    nameZA: 'Nombre (Z-A)',
    emailAZ: 'Correo (A-Z)',
    emailZA: 'Correo (Z-A)',
    memberIdAZ: 'ID de Miembro (A-Z)',
    memberIdZA: 'ID de Miembro (Z-A)',
    statusActiveFirst: 'Estado (Activos Primero)',
    statusInactiveFirst: 'Estado (Inactivos Primero)',
    accountInformation: 'Información de Cuenta',
    contactInformation: 'Información de Contacto',
    profileInformation: 'Información de Perfil',
    emergencyContact: 'Contacto de Emergencia',
    lifestyleInformation: 'Información de Estilo de Vida',
    preferences: 'Preferencias',
    receiveEmailAlerts: 'Recibir Alertas por Correo',
    receiveSmsNotifications: 'Recibir Notificaciones SMS',
    subscribeToNewsletter: 'Suscribirse al Boletín',
    cancel: 'Cancelar',
    close: 'Cerrar',
    updatePatient: 'Actualizar Paciente',
    addPatient: 'Agregar Paciente',
    patientDetails: 'Detalles del Paciente',
    medicalInformation: 'Información Médica',
    deletePatientConfirmation: '¿Está seguro de que desea eliminar',
    deletePatientWarning: 'Esta acción no se puede deshacer y eliminará permanentemente todos los datos del paciente.',
    createCardErrorRequired: 'Por favor, complete todos los campos requeridos.',
    creatingCard: 'Creando Tarjeta...',
    // Field validation errors
    allergiesRequired: 'Se requiere al menos una alergia',
    medicationsRequired: 'Se requiere al menos un medicamento',
    conditionsRequired: 'Se requiere al menos una condición',
    hospitalsRequired: 'Se requiere al menos un hospital',
    doctorsRequired: 'Se requiere al menos un doctor',
    primaryPhoneRequired: 'Se requiere número de teléfono primario',
    secondaryPhoneRequired: 'Se requiere número de teléfono secundario',
    secondaryMobileRequired: 'Se requiere número de móvil secundario',
    religionRequired: 'Se requiere religión',
    ekgRequired: 'Se requiere ECG',
    bloodTypeRequired: 'Se requiere tipo de sangre',
    dobRequired: 'Se requiere fecha de nacimiento',
    ssnRequired: 'Se requiere SSN',
    invalidPhoneNumber: 'Por favor, ingrese un número de teléfono válido',
    invalidMobileNumber: 'Por favor, ingrese un número de móvil válido',
    invalidDateFormat: 'Por favor, ingrese una fecha válida en formato MM/DD/AAAA',
    dateInFuture: 'La fecha de nacimiento no puede estar en el futuro',
    dateInvalid: 'Por favor, ingrese una fecha de nacimiento válida',
    invalidSSNFormat: 'Por favor, ingrese un formato de SSN válido (XXX-XX-XXXX)',
    // API error messages
    validationError: 'Error de validación',
    primaryPhoneInvalid: 'El número de teléfono primario no es válido',
    bloodTypeInvalid: 'El tipo de sangre no es válido',
    dateOfBirthInvalid: 'La fecha de nacimiento no es válida',
    ssnInvalid: 'El SSN no es válido',
    // Field specific errors
    allergiesEmpty: 'La lista de alergias no puede estar vacía',
    medicationsEmpty: 'La lista de medicamentos no puede estar vacía',
    conditionsEmpty: 'La lista de condiciones no puede estar vacía',
    hospitalsEmpty: 'La lista de hospitales no puede estar vacía',
    doctorsEmpty: 'La lista de doctores no puede estar vacía',
    // Additional validation messages
    phoneNumberFormat: 'El formato del número de teléfono debe ser XXX-XXX-XXXX',
    mobileNumberFormat: 'El formato del número móvil debe ser XXX-XXX-XXXX',
    dobFormat: 'El formato de fecha debe ser MM/DD/AAAA',
    dobFutureDate: 'La fecha de nacimiento no puede ser una fecha futura',
    dobTooOld: 'La fecha de nacimiento parece demasiado antigua',
    ssnFormat: 'El formato de SSN debe ser XXX-XX-XXXX',
    religionEmpty: 'Por favor seleccione una religión',
    ekgEmpty: 'El campo EKG no puede estar vacío',
    // Verification Modal translations (Spanish)
    verifyEmail: 'Verificar Su Correo Electrónico',
    verificationDescription: 'Hemos enviado un código de verificación de 4 dígitos a',
    enterVerificationCode: 'Ingrese Código de Verificación',
    resendIn: 'Reenviar código en',
    resendCode: 'Reenviar Código',
    verifying: 'Verificando...',
    verificationHelp: '¿No recibió el código? Revise su carpeta de spam o intente reenviar.',
    verificationCodeRequired: 'Por favor, ingrese un código de verificación de 4 dígitos válido',
    verificationFailed: 'La verificación falló. Por favor, intente de nuevo.',
    resendFailed: 'No se pudo reenviar el código. Por favor, intente de nuevo.',
    dateOfBirth2: 'MM/DD/YYYY',

  },
};

export function t(key, lang = 'en') {
  return translations[lang]?.[key] || translations['en'][key] || key;
} 